import { render, staticRenderFns } from "./PostalCodeBase.vue?vue&type=template&id=47349fd0&scoped=true&"
import script from "./PostalCodeBase.vue?vue&type=script&lang=js&"
export * from "./PostalCodeBase.vue?vue&type=script&lang=js&"
import style0 from "./PostalCodeBase.vue?vue&type=style&index=0&id=47349fd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47349fd0",
  null
  
)

export default component.exports